export default __webpack_public_path__ + "media/search/pointer-0d929097.svg";